<template>
  <Layout>
    <v-layout
      class="pt-4"
      row
      wrap>
      <v-flex
        lg5
        xs12>
        <OilTotalConsumptionChart
          :key="'total' + componentKey"
          :workshop-id="worshopId" />
      </v-flex>
      <v-flex
        lg7
        xs12>
        <OilVolumeChangeChart
          :key="'oilVolume' + componentKey"
          :workshop-id="worshopId" />
      </v-flex>
      <v-flex
        xs12
        class="pt-5">
        <WorkshopDevicesTable
          :workshop-id="worshopId"
          @data-updated="onDataUpdatedHandler" />
      </v-flex>
      <v-flex
        xs12
        class="pt-5 pl-3">
        <!-- [place for Notifications table] -->
      </v-flex>
    </v-layout>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import OilVolumeChangeChart from './components/oil-volume-change-chart'
import OilTotalConsumptionChart from './components/oil-total-consumption-chart'
import WorkshopDevicesTable from './components/workshop-devices-table'

export default {
  name: 'Workshop',
  metaInfo: {
    title: 'Workshop',
    meta: [{ name: 'description', content: 'Workshop' }],
  },
  components: {
    Layout,
    OilVolumeChangeChart,
    OilTotalConsumptionChart,
    WorkshopDevicesTable,
  },
  data: () => ({
    worshopId: null,
    componentKey: 0,
  }),
  created() {
    this.worshopId = this.$route.params.id
    // this.prepareFilters()
    // this.getPaginator()
    // this.fetchData()
  },
  methods: {
    forceRerender() {
      this.componentKey += 1
    },
    onDataUpdatedHandler() {
      this.forceRerender()
    },
  },
}
</script>
